"use client";

import { useTranslation } from "@/hooks/useTranslation";

type Props = {
  backToFormAction: () => void;
};

export default function FeedbackDoneInfo({ backToFormAction }: Props) {
  const { t } = useTranslation();
  return (
    <div className="flex h-full items-center justify-center bg-white p-4 shadow-md">
      <div className="py-8 text-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="mx-auto mb-4 size-16 text-green-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <h3 className="mb-2 text-2xl font-bold">
          {t({ en: "Thank you!", de: "Danke!" })}
        </h3>
        <p className="mb-4 text-gray-600">
          {t({
            de: "Vielen Dank für Ihr Feedback. Es ist sehr hilfreich für uns.",
            en: "Thank you for your feedback; it's very helpful.",
          })}
        </p>
        <button
          onClick={backToFormAction}
          className="mt-5 rounded-full border-none bg-primary-500 px-8 py-4 font-bold text-gray-50 transition duration-300 hover:bg-primary-400"
        >
          {t({ de: "Zurückgehen", en: "Go back" })}
        </button>
      </div>
    </div>
  );
}
